module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "CopyrightPage",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("Copyright © 2022 by Mitzi Szereto."), _c('br'), _vm._v("Published by Mango Publishing, a division of Mango Publishing Group, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_vm._v("Cover Design: & Art Direction Elina Diaz"), _c('br'), _vm._v("Cover Photo: fotoru/Adobe Stock"), _c('br'), _vm._v("Layout & Design: Katia"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("Mena")]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_vm._v("Mango is an active supporter of authors’ rights to free speech and artistic expression in their books. The purpose of copyright is to encourage authors to produce exceptional works that enrich our culture and our open"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("society.")]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_vm._v("Uploading or distributing photos, scans or any content from this book without prior permission is theft of the author’s intellectual property. Please honor the author’s work as you would your own. Thank you in advance for respecting our author’s"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("rights.")]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_vm._v("For permission requests, please contact the publisher at:"), _c('br'), _vm._v("Mango Publishing Group"), _c('br'), _vm._v("2850 S Douglas Road, 4th Floor"), _c('br'), _vm._v("Coral Gables, FL 33134 USA"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:info@mango.bz"
    }
  }, [_vm._v("info@mango.bz")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_vm._v("For special orders, quantity sales, course adoptions and corporate sales, please email the publisher at "), _c('a', {
    attrs: {
      "href": "mailto:sales@mango.bz"
    }
  }, [_vm._v("sales@mango.bz")]), _vm._v(". For trade and wholesale sales, please contact Ingram Publisher Services at "), _c('a', {
    attrs: {
      "href": "mailto:customer.service@ingramcontent.com"
    }
  }, [_vm._v("customer.service@ingramcontent.com")]), _vm._v(" or +1.800.509.4887.")]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_vm._v("The Best New True Crime Stories: Unsolved Crimes & Mysteries")]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_vm._v("Library of Congress Cataloging-in-Publication number: 2022939118"), _c('br'), _vm._v("ISBN: (print) 978-1-64250-941-0, (ebook) 978-1-64250-942-7"), _c('br'), _vm._v("BISAC category code SOC051000, SOCIAL SCIENCE / Violence in"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("Society")]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_vm._v("Printed in the United States of"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("America")]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("The accounts in this book are true and accurate to the best of our knowledge. They may contain speculation by the author(s) and opinions/analyses from psychology, criminology, and forensics experts. Although the publisher, editor, and authors have made every effort to ensure that the information in this book was correct at press time, and while this book is designed to provide accurate information in regard to the subject matter, the publisher, editor, and authors assume no responsibility for errors, inaccuracies, omissions, or any other inconsistencies herein and hereby disclaim any liability to any party resulting from such errors or")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  })]), _c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("omissions.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32555650","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheBestNewTrueCrimeStories-4.vue
// module id = 69
// module chunks = 0